import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14ab9586&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=14ab9586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab9586",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ToggleClientDropdown: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/ToggleClientDropdown.vue').default,DescriptionText: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/DescriptionText.vue').default,Product: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Product.vue').default,Divider: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Divider.vue').default,CollectionTile: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/CollectionTile.vue').default})
